import { Product } from "../types/types"

export const ToltraMax: Product = {
  id: "toltramax-10-pct-120ml",
  name: "ToltraMax 10% for Horses, Dogs, Cats 120mL",
  description: "Introducing ToltraMax, the ultimate Toltrazuril 10% solution, expertly formulated for the effective management and prevention of coccidiosis in a wide range of animals including dogs, cats, and horses. This broad-spectrum antiprotozoal agent is your go-to defense, ensuring your animals stay healthy, vigorous, and productive.",
  price: 40,
  category: "medication",
  imageUrl: "/static/images/toltramax-120.jpg",
  hpr_product_id: '423558',
  hpr_variation_id: '423563',
  hpr_attribute_name: 'attribute_pa_flavors',
  hpr_attribute_value: 'peanut-butter',
}

export const PonaMax: Product = {
  id: "ponamax-10",
  name: "PonaMax 10% for Horses, Dogs, Cats 120mL",
  description: "Introducing PonaMax, the premier Ponazuril 10% solution, strategically formulated to treat and manage protozoal infections across a diverse range of animals, including horses, cats, dogs. This versatile and potent treatment is specifically designed to combat Equine Protozoal Myeloencephalitis (EPM) and other protozoal diseases, safeguarding the health and enhancing the well-being of your animals.",
  price: 40,
  category: "medication",
  imageUrl: "/static/images/ponamax-120.png",
  hpr_product_id: '423613',
  hpr_variation_id: '423614',
  hpr_attribute_name: 'attribute_pa_flavors',
  hpr_attribute_value: 'apple',
}

export const Omep = {
  id: "omep-2-28-g-single",
  name: "Omeprazole Paste for Horses 2.28g Oral Syringe",
  description: "Get our Omeprazole Paste for Horses, 2.28g single dose, for treating gastric ulcers and stomach acid problems. Designed for horses, this easy-to-use supplement treats stomach acid-related issues. such as gastroesophageal reflux disease (GERD), peptic ulcers, and Zollinger-Ellison syndrome, with a simple daily single dose of our Omeprazole paste. Ideal for maintaining your horse’s digestive health.",
  price: 12,
  category: "medication",
  imageUrl: "/static/images/omep-2-28g.jpg",
  hpr_product_id: '416212',
  hpr_variation_id: '416214',
  hpr_attribute_name: 'attribute_pa_flavor',
  hpr_attribute_value: 'Cinnamon',
}

export const AllProducts = [
  ToltraMax, PonaMax, Omep,
]
